import { Avatar, Box, Button, IconButton, Input, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CustomAlert from "../../events/components/CustomAlert"
import { updateReviewState } from "../../../redux/reviewSlice";
import { useDispatch, useSelector } from "react-redux";
import CheckIcon from "../../../components/icons/CheckIcon";
import edit from '../../../assets/editExtendIcon.svg'
import { updateCreationState } from "../../../redux/eventCreationSlice";
import { afterValidate, generateDarkColor, getInitials, setInput, timeStampToDateString, timeStampToDayString, timeStampToNumberedDateString } from "../../../utils/commonServices";
import { LoadingButton } from "@mui/lab";
import { updateTeamState } from "../../../redux/teamSlice";
import CustomInput from "../../eventcreation/components/CustomInput";
import CustomAutocomplete from "../../eventcreation/components/CustomAutoComplete";
import CustomButton from "../../../components/CustomButton";
import { getErrorMsg } from "../../../utils/validator";
import { exampleTeamMembers } from "../../../constants/staticData";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";
import { useLocation, useNavigate } from "react-router-dom";
// import { customTheme as theme } from "../../../theme/customTheme";
import { getRoleNamesFromIds } from "../../../commonactions/actions";
import MembersList from "../../teams/components/MembersList";
import OrganisationMembersList from "./OrganisationMembersList";
import useCustomTheme from "../../../theme/useCustomTheme";
import useDashboardActions from "../useDashboardActions";
import { updateState } from "../../../redux/commonSlice";




const useStyles = makeStyles((theme) => ({

  expanded: {
    width:'60%'
  }
}));



const InviteOrganisationMembersPopup = (props) => {
    const {  options } = props
   
    const dispatch = useDispatch()
    const [searchTerm, setSearchTerm] = useState('');
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const [emailValidationFlag, setEmailValidationFlag] = useState(false);
    const [roleValidationFlag, setRoleValidationFlag] = useState(false);
    const [inviteButtonState, setInviteButtonState] = useState('Invite')
    // const [members, setMembers] = useState(teamsReducer.organization_members)
    const [members, setMembers] = useState(commonReducer.organisation_members_list)
    const {addOrganisationMember} = useDashboardActions()
    // const [testmembers, setTestmembers] = useState(members)
   
    const [searchedArray, setSearchedArray] = useState(members)
    const colors = ['red', 'pink', 'black'];

    const initialPageData = {
      email: "" ,
      role_id:""      
    }

    const [pageData, setPageData] = useState(initialPageData)

    const isButtonDisabled = pageData.email == '' || pageData.role_id == '' 
    const location = useLocation()
    const navigate = useNavigate()
    const [theme ] = useCustomTheme()





    
    // useEffect(()=>{
    //   setSearchedArray(teamsReducer?.organization_members)
    // },[teamsReducer?.organization_members])

        
    useEffect(()=>{
      setSearchedArray(commonReducer.organisation_members_list)
    },[commonReducer.organisation_members_list])

  
  
    const inviteClickHandler = () => {
      setEmailValidationFlag(true)
      setRoleValidationFlag(true)
      afterValidate(sendInvite)
    }

    const sendInvite = () =>{
      addOrganisationMember(pageData, afterInviteCallback )
      setInviteButtonState("Invite Sent!")
      // setTimeout(() => {
      //   setInviteButtonState('Invite')
      //   setPageData(initialPageData)
      //   setEmailValidationFlag(false)
      //   setRoleValidationFlag(false)
      // }, 1500)

    }

    const afterInviteCallback =()=>{
      setInviteButtonState('Invite')
      setPageData(initialPageData)
      setEmailValidationFlag(false)
      setRoleValidationFlag(false)
    }

    const handleClose = () => {
      !teamsReducer.is_loading && dispatch(updateState({invite_org_members_popup : false}))      
    };

  

  const handleAutocompleteChange = (event, value) => {
    setPageData((last) => {
      return { ...last, role_id: value.id };
  });
  }; 

  const handleSearch = (e) => {
    const searchedInput = e.target.value.toLowerCase();
    if (!searchedInput.startsWith(' ')) {
      setSearchTerm(searchedInput);
    }

    const updatedFiles = [...members];

    const results = updatedFiles?.filter(item =>
      item.name?.toLowerCase().includes(searchedInput) ||
      item.email?.toLowerCase().includes(searchedInput)||
      item.role?.name?.toLowerCase().includes(searchedInput)
    );
    setSearchedArray(results);
  };

    return (
        <CustomAlert 
          open={commonReducer.invite_org_members_popup} 
          handleClose={handleClose} 
          height={{xs:'420px', md:'75%',lg:'70%',xl:'600px'}}
          width={{md:'65%',lg:'65%', xl:'1400px'}}
          rightComponent={
            <Box component='div' className= 'flex col a-start' sx={{paddingX:{xs:'10px',md:'1rem', lg:'1.2rem', xl:'2rem'},height:'100%',  overscrollBehaviorBlock:'contain', overflowY:'auto', width:'100%', justifyContent:{md:'center'}, paddingTop:{xs:2,sm:3, md:1, lg:0}}}>
            {/* <Box  sx={{height: '100%',  overscrollBehaviorBlock:'contain', overflowY:'auto', width:'100%', justifyContent:{sm:'center'}}} className='flex col a-start'>  */}
              <Typography sx={{fontSize:{xs:'8px',md:'9px',lg:'10px', xl:'14px'}, fontWeight:600, fontFamily:'Rubik', color:'#000'}} >{`Admin(Project Manager)`}</Typography>
              <Box component='ul' pl={1} mt={0} style={{listStyleType: 'disc'}} mb={{xs:1, md:1.5, lg:2.5}}>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Oversees video projects </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Assigns editors </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Manages timelines and deliverables  </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Reviews uploaded videos </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Submits revision requests  </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Ensures all client feedback is addressed </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik',textAlign:'justify', color:'#000'}}>Approves Final Videos  </Typography>
              </Box>

           
              <Typography sx={{fontSize:{xs:'8px',md:'9px',lg:'10px', xl:'14px'}, fontWeight:600, textAlign:'justify', fontFamily:'Rubik', color:'#000'}}>Editors</Typography>
              <Box component='ul' pl={1} style={{listStyleType: 'disc'}} mt={0}  mb={{xs:1, md:1.5, lg:2.5}}>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Reviews client and PM feedback </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Edits videos and applies revision notes</Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Tracks tasks using the checklist </Typography>
                <Typography component='li' sx={{fontSize:{xs:'7px',md:'8px',lg:'9px', xl:'12px'}, fontFamily:'Rubik', textAlign:'justify', color:'#000'}}>Uploads new video versions</Typography>
              </Box>
             
            {/* </Box> */}
          </Box>}
          >       
            <Box sx={{display:'flex', flexDirection:'column', height:'100%'}} px={4} pt={3} pb={2}>
              <Box flexGrow={1} pt={1} >
                  <Typography mb={1} sx={{fontWeight:600, fontFamily:'Rubik', fontSize:{xs:'16px',sm:'16px',md:'18px',lg:'20px',xl:'27px'}, color:'#000'}}>Invite with email</Typography>
                  <Box gap={2} style={{display:'flex'}} mb={1}>
                            <Box style={{width:'40%'}}>
                              <CustomInput
                                onFocus={()=>setEmailValidationFlag(false)}
                                onBlur={()=>setEmailValidationFlag(true)}
                                disabled = {teamsReducer.is_loading}
                                required
                                errorFlag={
                                  emailValidationFlag &&
                                  getErrorMsg("email", pageData?.email) != ""
                                }
                                errorMsg={getErrorMsg("email", pageData?.email)}
                                type="email"
                                max={40}
                                placeholder="Add members by email..."
                                onChange={(event) => {
                                  setInput(
                                    pageData?.email != ""
                                    ? event.target.value
                                    : event.target.value.trim(),
                                    "email",
                                    pageData,
                                    setPageData
                                  );
                                }}
                                value={pageData?.email}
                              />
                    
                            </Box>
                            <Box style={{width:'25%'}}>         
                              <CustomAutocomplete
                                options={options}
                                placeholder='Set as...'
                                onFocus={() => {
                                  setEmailValidationFlag(true)
                                  setRoleValidationFlag(false)
                                }}
                                disabled = {teamsReducer.is_loading}
                                onBlur={() => setRoleValidationFlag(true)}
                                required
                                errorFlag= {roleValidationFlag && getErrorMsg("role_type", pageData?.role_id) != ""}
                                errorMsg= {getErrorMsg("role_type", pageData?.role_id)}
                                onChange={handleAutocompleteChange}
                                value={getRoleNamesFromIds(pageData?.role_id, options)}
                                getOptionLabel={(option) =>
                                Object.keys(option).length > 0 ? option.name : ""
                                }
                                />
                            </Box>
                            <Box>
                              <CustomButton variant='contained' color='secondary' btnText={inviteButtonState} disabled = {teamsReducer.is_loading} type='button' onClick={inviteClickHandler}  sx={{
                              // backgroundColor:theme.palette.secondary.main,
                               borderRadius:'5px', border:'none', fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, padding:'10px', width:'6.1rem', fontWeight:600, textTransform:'none', height:{xs:'18px',sm:'18px',md:'20px',lg:'22px',xl:"36px"},fontFamily:'Rubik' }}/>
       
                            </Box>
                  </Box>
                  <Box className='flex col' gap={1.5} >
                    <Box className='flex j-between a-center' style={{width:{xs:'90%', md:'80%'}}}>
                      <Typography sx={{fontWeight:600, fontFamily:'Rubik', color:'#000', fontSize:{xs:'16px',sm:'16px',md:'18px',lg:'20px',xl:'27px'}}}>Members ({commonReducer.organisation_members_list?.length})</Typography>
                      <Box id="search" className='flex j-end' pr={2}>
                        <Input
                          id="search-input"
                          disabled = {teamsReducer.is_loading}
                        value={searchTerm}
                        onChange={handleSearch}
                        inputProps={{ maxLength: 50 }}
                        sx={{
                            borderColor: "transparent",
                            input: {
                                fontSize: { xs: '12px', md: '12px', lg: '13px', xl: '16px' },
                                fontWeight: 400,
                                color: "#000000",
                              
                            },
                           
                            justifySelf:'flex-end',
                            width:'60%', 
                            transition: 'width 0.3s ease',
                    
                        }}
                        placeholder="Search"
                        startAdornment={
                            <IconButton sx={{paddingBottom:0.5, fontSize: {xs:'12px',md:'14px',lg:'17px',xl:'24px'}, '& .MuiSvgIcon-root':{fontSize:{xs:'12px',md:'14px',lg:'15px',xl:'20px'}}, paddingRight:2}} >
                                <SearchIcon style={{ color: "#000000" }} />
                            </IconButton>
                        }
                        />
                    </Box>
                    </Box>
                    <Box sx={{height:'22vh', overflowY:'auto'}} pr={2}>

                      {searchedArray?.length > 0 ? searchedArray?.map((member, index) => {
                        return  <OrganisationMembersList color={generateDarkColor(member, 'name')}   member={member} index={index} searchedArray={searchedArray} roleOptions={options}/>
                      }) : 
                       <Box className= 'flex col j-center a-center' sx={{overflowY: "initial", whiteSpace: 'normal'}} height='100%' width='100%'>
                          <Typography sx={{fontSize:{xs:'16px',sm:'16px',md:'18px',lg:'20px',xl:'27px'}, color: '#878887', fontWeight: 300, textAlign: 'center', fontFamily:'Rubik'}} >No results found.
                          </Typography>
                        </Box>
                      }
                  
                    </Box>
                  </Box>
  
              </Box>

              {/* <Box sx={{display:'flex', flexDirection:'column', justifyContent:'flex-end', alignItems:'end'}}>
               <Box pr={1.5}>

               { requestStatus == 'loading'  ? <LoadingButton
                  
                    sx={{
                        '& .MuiLoadingButton-loadingIndicator': {
                            color: theme.palette.primary.main,
                        },
                        height: {xs:'36px',sm:'40px',md:'45px', lg:'51px',xl:'75px'},
                       minWidth: {xs:'36px !important',sm:'40px !important',md:'45px !important', lg:'51px !important',xl:'75px !important'},
                        backgroundColor: '#08231B'
                    }}
                    loading={requestStatus == 'loading'}
                    variant="outlined"
                    disabled
                    >
                   
               </LoadingButton> :
               <CheckIcon onClick= {submitRequestClickHandler}  sx={{fontSize:{xs:'40px',sm:'44px',md:'50px', lg:'56px',xl:'82px'}, cursor: 'pointer'}}/>
               }
                 
                </Box>
              <Box>    
                <Button 
                variant="text"
                onClick={handleClose}
                 sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"}, width:{xs:'70px',sm:'70px',md:'80px',lg:'90px',xl:'120px'}, fontFamily:'Rubik', textTransform:'none', letterSpacing:'0.65px', textDecoration:'underline'}}
                >
                Or Go Back
               </Button>
              </Box>
            </Box> */}
          </Box>
       
        </CustomAlert>
      )
}

export default InviteOrganisationMembersPopup








